import { create } from "zustand";

type SortOrder = "asc" | "desc";

type ShelfStoreState = {
  selectedShelf: string | null;
  shelfSortOrder: SortOrder;
  setSelectedShelf: (shelf: string | null) => void;
  toggleShelfSortOrder: () => void;
  reset: () => void;
};

const initialState: Pick<ShelfStoreState, "selectedShelf" | "shelfSortOrder"> = {
  selectedShelf: "all",
  shelfSortOrder: "asc",
};

export const useShelfStore = create<ShelfStoreState>()((set) => ({
  ...initialState,
  setSelectedShelf: (shelf) => set({ selectedShelf: shelf }),
  toggleShelfSortOrder: () =>
    set((state) => ({
      shelfSortOrder: state.shelfSortOrder === "asc" ? "desc" : "asc",
    })),
  reset: () => set(initialState),
}));
